const select = (state) => state.error;

export const errorSelector = (state) => select(state).error;
export const errorTypeSelector = (state) => select(state).errorType;
